import React, { useState, useCallback } from "react";
import { FormCheckbox } from "../../components/ui";
import { trackComment, stopTrackingComment } from "api";

const CommentNotification = ({ commentId, comment, currentUser }) => {
  const commentCreatorId = comment && comment.user && comment.user.id;
  const currentUserId = currentUser && currentUser.id;
  const [waitingNotification, setWaitingNotification] = useState(
    comment && comment.tracking
  );
  const [loading, setLoading] = useState(false);

  const handleCommentTracking = useCallback(async () => {
    if (!waitingNotification) {
      setLoading(true);

      try {
        await trackComment(commentId);
        setWaitingNotification(true);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }

    if (waitingNotification) {
      setLoading(true);
      try {
        await stopTrackingComment(commentId);
        setWaitingNotification(false);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  });

  if (commentCreatorId === currentUserId) {
    return null;
  }

  return (
    <FormCheckbox
      style={{ minHeight: "10px" }}
      disabled={loading}
      toggle
      small
      checked={waitingNotification}
      onChange={handleCommentTracking}
    >
      <span className="likes" style={{ display: "inline-block" }}>
        Notify me if analyst replies to this comment
      </span>
    </FormCheckbox>
  );
};

export default CommentNotification;
